import React from 'react';
import Carousel from './Carousel';
import BrandSection from '../pages/BrandSection';
import PopularCarsSection from '../pages/PopularCarsSection';
import CarTypeSection from '../pages/CarTypeSection';
import WhyChooseUsSection from '../pages/WhyChooseUsSection';
import GallerySection from '../pages/GallerySection';
import FeaturedCars from '../pages/FeaturedCars';
import BlogSection from '../pages/BlogSection';
import TopRoutesSection from '../pages/TopRoutesSection';



const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">

<Carousel/>
<BrandSection/>
<TopRoutesSection/>
<PopularCarsSection/>
{/* <CarTypeSection/> */}
<WhyChooseUsSection/>
<GallerySection/>
<FeaturedCars/>
<BlogSection/>
    </div>
  );
};

export default HeroSection;
